const reportWebVitals = (onPerfEntry?: (metric: any) => void) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB, onINP }) => {
      onCLS && onCLS(onPerfEntry);
      onFCP && onFCP(onPerfEntry);
      onLCP && onLCP(onPerfEntry);
      onTTFB && onTTFB(onPerfEntry);
      onINP && onINP(onPerfEntry);
    });
  }
};

export default reportWebVitals;
